import { render } from "./time-icon-svg.vue?vue&type=template&id=06f91fa2&ts=true"
import script from "./time-icon-svg.vue?vue&type=script&lang=ts"
export * from "./time-icon-svg.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__